export default function calendar() { 
     const calendar = flatpickr("#calendar", {
    mode: "range",
    inline: true,
    dateFormat: "d/m/Y",
    locale: "pt",
    onChange: function(selectedDates) {
      console.log("Intervalo selecionado:", selectedDates);
    }
  });

  document.getElementById("clear-btn").addEventListener("click", () => {
    calendar.clear();
  });

  document.getElementById("filter-btn").addEventListener("click", () => {
    const range = calendar.selectedDates;
    if (range.length === 2) {
      alert(`Filtrando de ${range[0].toLocaleDateString()} até ${range[1].toLocaleDateString()}`);
    } else {
      alert("Selecione um intervalo completo!");
    }
  });
}
